/** @format */

import React from 'react';
import { Table } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import { SearchCustomerItem } from '../services/searchCustomer';

interface CustomersTableProps {
  customers: SearchCustomerItem[];
  loading: boolean;
  onView?: (customer: SearchCustomerItem) => void;
}

const CustomersTable: React.FC<CustomersTableProps> = ({
  customers,
  loading,
  onView,
}) => {
  const columns: ColumnsType<SearchCustomerItem> = [
    {
      title: 'First Name',
      dataIndex: 'firstName',
      key: 'firstName',
      sorter: (a, b) => (a.firstName || '').localeCompare(b.firstName || ''),
    },
    {
      title: 'Last Name',
      dataIndex: 'lastName',
      key: 'lastName',
      sorter: (a, b) => (a.lastName || '').localeCompare(b.lastName || ''),
    },
    {
      title: 'Member ID',
      dataIndex: 'memberId',
      key: 'memberId',
    },
    {
      title: 'Phone Number',
      dataIndex: 'phoneNumber',
      key: 'phoneNumber',
    },
    {
      title: 'Office',
      key: 'office',
      render: (_, record) => record.office?.officeName || 'N/A',
    },
    {
      title: 'Agent',
      key: 'agent',
      render: (_, record) =>
        record.user
          ? `${record.user.firstName || ''} ${record.user.lastName || ''}`.trim()
          : 'N/A',
    },
    {
      title: 'Action',
      key: 'action',
      render: (_, record) => (
        <button
          className='view-button'
          onClick={() => onView?.(record)}
          style={{
            padding: '4px 12px',
            backgroundColor: '#1890ff',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
          }}
        >
          View
        </button>
      ),
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={customers}
      rowKey={(record) => record._id || record.memberId || `${record.firstName}-${record.lastName}-${record.phoneNumber}`}
      loading={loading}
      pagination={{
        pageSize: 50,
        showSizeChanger: true,
        pageSizeOptions: ['25', '50', '100'],
      }}
      scroll={{ x: 'max-content' }}
    />
  );
};

export default CustomersTable;
